import { TZDate } from '@date-fns/tz';
import { format as formatFns } from 'date-fns/format';
import type { Locale } from 'date-fns/locale';
import { nb } from 'date-fns/locale/nb';

const osloTimezone = 'Europe/Oslo';
const defaultLocale = nb;

export class ZonedDate extends TZDate {}

const isValidDate = (date: Date | string): boolean => !Number.isNaN(new Date(date).getTime());

export function getZonedDate(
    date: Date | string | undefined = new Date(),
    { timeZone } = { timeZone: osloTimezone },
): ZonedDate {
    if (!isValidDate(date))
        throw new Error(
            `Invalid date so could not create ZonedDate, input type: ${typeof date}. input value: ${date}. Timezone ${timeZone}`,
        );
    try {
        if (typeof date === 'string') return new ZonedDate(date).withTimeZone(timeZone); // This is done to choose correct overload
        return new ZonedDate(date).withTimeZone(timeZone);
    } catch (e) {
        throw new Error(`Failed to create ZonedDate from ${typeof date}; ${date}, with timezone ${timeZone}. ${e}`);
    }
}

const defaultOptions = { locale: defaultLocale, timezone: osloTimezone };

export const format = (date: Date | string, pattern: string, options?: { timezone?: string; locale?: Locale }) => {
    const { timezone, locale } = { ...defaultOptions, ...options };
    const targetDate = typeof date === 'string' ? new TZDate(date) : date;
    return formatFns(new TZDate(targetDate).withTimeZone(timezone), pattern, { locale });
};
